import { useColorMode } from '@chakra-ui/react';
import { useAppKitTheme } from '@reown/appkit/react';
import React from 'react';
import { WagmiProvider } from 'wagmi';

import config from 'configs/app';
import WalletInitModule from 'lib/web3/wagmiConfig';

const feature = config.features.blockchainInteraction;

interface Props {
  children: React.ReactNode;
}

const DefaultProvider = ({ children }: Props) => {
  return (
    <WagmiProvider config={WalletInitModule.getWagmiConfig()}>
      { children }
    </WagmiProvider>
  );
};

const ReownModalProvider = ({ children }: Props) => {
  const { colorMode } = useColorMode();
  const { setThemeMode } = useAppKitTheme();

  React.useEffect(() => {
    setThemeMode(colorMode);
  }, [ colorMode, setThemeMode ]);

  return (
    <DefaultProvider>
      { children }
    </DefaultProvider>
  );
};

const Provider = feature.isEnabled ? ReownModalProvider : DefaultProvider;

export default Provider;
